@if (!isSeeOnly()) {
  <div class="fu-bar" [class.fu-bar--has-file]="!!fileName() || !!serverFileId()">
    <div class="fu-bar__info">
      <span
        class="fu-bar__dot"
        [class.fu-bar__dot--active]="!!fileName() || !!serverFileId()"
      ></span>
      <span class="fu-bar__name">
        {{ (fileName() || 'upload_your_file') | transloco }}
      </span>
    </div>
    <button class="fu-bar__btn" type="button" (click)="fileInput.click()">
      <i class="pi pi-upload"></i>
      {{ 'upload_file' | transloco }}
    </button>
    <input
      type="file"
      [accept]="acceptFileTypes()"
      #fileInput
      id="fileInput"
      hidden
      (change)="onFileSelected($event)"
    />
  </div>
}

@if (serverFileId() && !canDownload() && !uploadedFile()) {
  <div
    class="fu-preview-card fu-preview-card--locked"
    [pTooltip]="downloadTooltip() || ('download_not_available_yet' | transloco)"
    tooltipPosition="top"
  >
    <div class="fu-preview-card__info">
      <span class="fu-preview-card__icon-wrap fu-preview-card__icon-wrap--locked">
        <i class="pi pi-lock"></i>
      </span>
      <div>
        <p class="fu-preview-card__name">
          {{ 'variant_question_files' | transloco }}
        </p>
        <p class="fu-preview-card__hint">
          {{
            downloadTooltip() ||
              ('download_not_available_yet' | transloco)
          }}
        </p>
      </div>
    </div>
    <span class="fu-preview-card__action fu-preview-card__action--disabled">
      <i class="pi pi-download"></i>
    </span>
  </div>
} @else if (filePreviewUrl()) {
  @if (isPdfPreview()) {
    <lib-app-pdf-viewer
      [pdfSource]="filePreviewUrl()"
      height="80vh"
      customClass="w-full rounded-lg shadow-lg"
    />
  } @else if (isWordPreview()) {
    <div class="fu-preview-card fu-preview-card--doc">
      <div class="fu-preview-card__info">
        <span class="fu-preview-card__icon-wrap fu-preview-card__icon-wrap--doc">
          <i class="pi pi-file-word"></i>
        </span>
        <div>
          <p class="fu-preview-card__name">{{ fileName() }}</p>
          <p class="fu-preview-card__hint">{{ 'document_preview_not_available' | transloco }}</p>
        </div>
      </div>
      @if (canDownload()) {
        <a [href]="filePreviewUrl()" [download]="fileName()" class="fu-preview-card__action">
          <i class="pi pi-download"></i>
        </a>
      } @else {
        <span
          class="fu-preview-card__action fu-preview-card__action--disabled"
          [pTooltip]="downloadTooltip()"
          tooltipPosition="top"
        >
          <i class="pi pi-download"></i>
        </span>
      }
    </div>
  } @else {
    <div class="fu-preview-card fu-preview-card--generic">
      <div class="fu-preview-card__info">
        <span class="fu-preview-card__icon-wrap">
          <i class="pi pi-file"></i>
        </span>
        <div>
          <p class="fu-preview-card__name">{{ fileName() }}</p>
          <p class="fu-preview-card__hint">{{ 'file_type_not_supported' | transloco }}</p>
        </div>
      </div>
      @if (canDownload()) {
        <a [href]="filePreviewUrl()" [download]="fileName()" class="fu-preview-card__action">
          <i class="pi pi-download"></i>
        </a>
      } @else {
        <span
          class="fu-preview-card__action fu-preview-card__action--disabled"
          [pTooltip]="downloadTooltip()"
          tooltipPosition="top"
        >
          <i class="pi pi-download"></i>
        </span>
      }
    </div>
  }
}
